let app = {

   init() {
      let pagin = document.querySelector('.page-liste-des-adherents')
      if (pagin) {
         let adherents = document.querySelectorAll('.wp-block-columns .wp-block-column:first-child')
         adherents.forEach((adherent) => {
            adherent.classList.add('active')
         })
         this.eventlisteners()
      }
   },

   eventlisteners() {
      [1, 2, 3].forEach((i) => {
         let target = document.querySelector('.wp-block-columns .wp-block-column:nth-child(' + i + ') h3')
         this.eventlistener(target, i)
      })
   },

   eventlistener(target, i) {
      target.addEventListener('click', () => {
         this.resetClass()
         let adherents = document.querySelectorAll('.wp-block-columns .wp-block-column:nth-child(' + i + ')')
         adherents.forEach((adherent) => {
            adherent.classList.add('active')
         })
      })
   },

   resetClass() {
      let adherents = document.querySelectorAll('.wp-block-columns .wp-block-column')
      adherents.forEach((adherent) => {
         adherent.classList.remove('active')
      })
   }

}

setTimeout(() => {
   app.init()
}, 0)
